export type PaymentType = {
  id: string;
  code?: string;
  name?: string;
  eType: number | null;
  eTypeString?: string;
  isFromManager: boolean;
  isActive?: boolean;
};

export enum ePaymentType {
  Cash = 0,
  Credit = 1,
  CreditCard = 2,
  PaymentChannel = 3,
  Bank = 4,
}
